module.exports = __webpack_public_path__ + "img/solar-panel-equipment.efdbe006.png";